// SWIPER
$(document).ready(function () {
    if ($(window).width() > 800) {
        var thumbs = new Swiper(".gallery-thumbs", {
            spaceBetween: 0,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesProgress: true,
        });
    } else {
        var thumbs = new Swiper(".gallery-thumbs", {
            spaceBetween: 0,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
        });
    }

    var swiper = new Swiper(".gallery-swiper", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: thumbs,
        },
    });
});

// POPUP
$(document).ready(function () {
    $(".popup-item").on("click", function () {
        var num = $(this).data("num");
        var imgSrc = $(".popup-item[data-num='" + num + "'] img").attr("src");
        $(".popup-content .popup-content__zoom img").attr("src", imgSrc);
        $(".popup-content").addClass("popup-show").fadeIn();
        $("body").css("height", "100vh");
        $("body").css("overflow-y", "hidden");
    });

    $("#popup-content__close").on("click", function () {
        $(".popup-content").removeClass("popup-show").fadeOut();
        $("body").css("height", "auto");
        $("body").css("overflow-y", "auto");
    });
});


// COPY TO CLIPBOARD
$(document).ready(function () {

    $("#access__copy").click(function () {

        var tempTextarea = $('<textarea>');
        $('body').append(tempTextarea);

        // Get the text from the paragraph and set it to the textarea
        tempTextarea.val($('#copyAddress').text()).select();

        // Copy the text inside the textarea
        navigator.clipboard.writeText(tempTextarea.val()).then(function () {
            // Alert the copied text
            alert("住所がクリップボードにコピーされました: " + tempTextarea.val());
        }).catch(function (err) {
            console.error('Failed to copy text: ', err);
        });

        // Remove the temporary textarea
        tempTextarea.remove();
    });

});